const RECENTLY_VIEWED_KEY = 'recently_viewed_products';
const MAX_ITEMS = 8;

function getRecentlyViewedItems() {
  try {
    const items = JSON.parse(
      localStorage.getItem(RECENTLY_VIEWED_KEY)
    );

    return Array.isArray(items) ? items : [];
  } catch (error) {
    return [];
  }
}

/* SAVE PRODUCT ON PRODUCT PAGE */
document.addEventListener('DOMContentLoaded', () => {
  if (typeof product === 'undefined' || !product.handle) return;

  let items = getRecentlyViewedItems();

  items = items.filter((handle) => handle !== product.handle);
  items.unshift(product.handle);
  items = items.slice(0, MAX_ITEMS);

  localStorage.setItem(
    RECENTLY_VIEWED_KEY,
    JSON.stringify(items)
  );
});

/* LOAD RECENTLY VIEWED PRODUCTS */
async function loadRecentlyViewedProducts() {
  const list = document.getElementById('recently-viewed-products');
  const section = document.getElementById('recently-viewed-section');

  if (!list || !section) return;

  const handles = getRecentlyViewedItems();

  if (!handles.length) return;

  const displayedHandles = new Set();
  const cleanedHandles = [];

  let hasProducts = false;

  for (const storedHandle of handles) {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}products/${storedHandle}?view=card`
      );

      if (!response.ok) continue;

      /*
       * Ja vecais produkta URL tiek novirzīts uz jauno URL,
       * response.url satur gala produkta adresi.
       */
      const finalUrl = new URL(response.url);
      const handleMatch = finalUrl.pathname.match(
        /\/products\/([^/?#]+)/
      );

      const finalHandle = handleMatch
        ? decodeURIComponent(handleMatch[1])
        : storedHandle;

      /*
       * Neielādē atkārtoti produktu, ja vecais un jaunais
       * handle aizved uz vienu un to pašu gala produktu.
       */
      if (displayedHandles.has(finalHandle)) continue;

      displayedHandles.add(finalHandle);
      cleanedHandles.push(finalHandle);

      const html = await response.text();

      const li = document.createElement('li');
      li.className = 'grid__item';
      li.innerHTML = html;

      list.appendChild(li);
      hasProducts = true;
    } catch (error) {
      console.warn(
        'Recently viewed product could not be loaded:',
        storedHandle,
        error
      );
    }
  }

  /*
   * Saglabā pārlūka atmiņā tikai gala handle bez dublikātiem.
   */
  localStorage.setItem(
    RECENTLY_VIEWED_KEY,
    JSON.stringify(cleanedHandles.slice(0, MAX_ITEMS))
  );

  if (hasProducts) {
    section.style.display = 'block';
  }
}

document.addEventListener(
  'DOMContentLoaded',
  loadRecentlyViewedProducts
);